import React from "react";
import classes from "./ProgressReportCardImage.scss";
import { getProgressReportCardImageStyle } from "ProgressReportCommon/utils";
import { ProgressReportOutlined } from "@toddle-edu/ds-icons";
import classNames from "classnames";
import { ProgressReportCardIcon } from "SvgComponents";

const ProgressReportCardImage = props => {
  const { width, height, index, isGlobalHeaderEnabled = false } = props;

  const imageStyles = getProgressReportCardImageStyle[index % 5];

  const imageContainerClass = classNames(classes.imageContainer, {
    [classes.imageContainerGlobalHeader]: isGlobalHeaderEnabled,
  });

  return (
    <div
      className={imageContainerClass}
      style={{ backgroundColor: imageStyles.backgroundColor }}
    >
      {isGlobalHeaderEnabled ? (
        <ProgressReportOutlined
          size="small"
          style={{ color: imageStyles.arrowStrokeColor }}
        />
      ) : (
        <ProgressReportCardIcon
          width={width}
          height={height}
          arrowStrokeColor={imageStyles.arrowStrokeColor}
        />
      )}
    </div>
  );
};

ProgressReportCardIcon.defaultProps = {
  height: 100,
  width: 100,
  index: 0,
};

export default ProgressReportCardImage;
